<template>
  <nav v-if="hasPages" class="mb-4" aria-label="Page navigation">
    <ul class="pagination pagination-lg justify-content-center">
      <!-- First -->
      <li
        :class="`page-item d-none d-md-block ${
          page <= start ? 'disabled' : ''
        }`"
      >
        <router-link
          :to="url"
          class="page-link"
          :aria-label="gettext('First page')"
        >
          <IconChevronLeft />
          <IconChevronLeft class="ms-n2" />
        </router-link>
      </li>

      <!-- Previous -->
      <li :class="`page-item ${page <= start ? 'disabled' : ''}`">
        <router-link
          :to="url + (page > start ? `?${pageQueryParam}=${page - 1}` : '')"
          class="page-link"
          :aria-label="gettext('Previous page')"
        >
          <IconChevronLeft />
        </router-link>
      </li>

      <!-- Pages around current page -->
      <li
        v-for="n in range"
        :key="page + n"
        :class="`page-item ${Math.abs(n) > 1 ? 'd-none d-md-block' : ''} ${
          page + n === page ? 'active' : ''
        }`"
      >
        <router-link
          :to="url + (page + n > start ? `?${pageQueryParam}=${page + n}` : '')"
          class="page-link"
          :aria-label="gettext('Page') + (page + n)"
        >
          {{ page + n }}
        </router-link>
      </li>

      <!-- Next -->
      <li :class="`page-item ${page >= end ? 'disabled' : ''}`">
        <router-link
          :to="`${url}?${pageQueryParam}=${page + 1}`"
          class="page-link"
          :aria-label="gettext('Next page')"
        >
          <IconChevronRight />
        </router-link>
      </li>

      <!-- Last -->
      <li
        :class="`page-item d-none d-md-block ${page >= end ? 'disabled' : ''}`"
      >
        <router-link
          :to="`${url}?${pageQueryParam}=${end}`"
          class="page-link"
          :aria-label="gettext('Last page')"
        >
          <IconChevronRight />
          <IconChevronRight class="ms-n2" />
        </router-link>
      </li>
    </ul>
  </nav>
</template>

<script>
import IconChevronLeft from '../../../../templates/icons/chevron-left.svg';
import IconChevronRight from '../../../../templates/icons/chevron-right.svg';

export default {
  components: {
    IconChevronLeft,
    IconChevronRight,
  },
  props: {
    // Base url
    url: {
      type: String,
      default: '/',
    },
    // Name of the query parameter to put the page number in
    pageQueryParam: {
      type: String,
      default: 'page',
    },
    // The current page
    page: {
      type: Number,
      default: 0,
    },
    // The number of pages to show on each side of the current page
    showExtra: {
      type: Number,
      default: 1,
    },
    // Start page number, 0 or 1 probably
    start: {
      type: Number,
      default: 0,
    },
    // Last page number
    end: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    range() {
      if (this.end - this.start < 1 + this.showExtra * 2) {
        // If there are less pages than the range would cover
        return new Array(this.end - this.start + 1)
          .fill(0)
          .map((v, i) => i - this.page + 1);
      } else if (this.page < this.start + this.showExtra) {
        // If the current page is all the way in the beginning
        return new Array(1 + this.showExtra * 2)
          .fill(0)
          .map((v, i) => -(this.page - this.start) + i);
      } else if (this.page > this.end - this.showExtra) {
        // If the current page is almost at the end
        return new Array(1 + this.showExtra * 2)
          .fill(0)
          .map((v, i) => this.end - this.page - i)
          .reverse();
      } else {
        // No edge cases, the preview numbers go from -n till +n
        return new Array(1 + this.showExtra * 2)
          .fill(0)
          .map((v, i) => 0 - this.showExtra + i);
      }
    },
    hasPages() {
      return this.range.length > 1;
    },
  },
};
</script>
